import { create } from "zustand";

interface TableState {
  tableId: string | null;
  setTableId: (tableId: string | null) => void;
  selectedNms: number[];
  setSelectedNms: (nms: number[]) => void;
}

export const useTableStore = create<TableState>((set) => ({
  tableId: null,
  setTableId: (tableId) => set({ tableId }),
  selectedNms: [],
  setSelectedNms: (selectedNms) => set({ selectedNms }),
}));
